import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Briefcase, Code } from 'lucide-react';
import './About.css';

const About = () => {
  const { t, isFrench } = useLanguage();

  const facts = isFrench ? [
    { label: 'Poste', value: 'Co-fondatrice & CTO' },
    { label: 'Entreprise', value: 'TheGift SAS' },
    { label: 'Formation', value: 'Master · 3iL Ingénieurs Limoges' },
    { label: 'Localisation', value: 'Limoges, France' },
  ] : [
    { label: 'Role', value: 'Co-founder & CTO' },
    { label: 'Company', value: 'TheGift SAS' },
    { label: 'Education', value: 'Master\'s · 3iL Ingénieurs Limoges' },
    { label: 'Location', value: 'Limoges, France' },
  ];

  const highlights = isFrench ? [
    'Co-fondatrice & CTO de TheGift SAS — publié sur App Store et Google Play',
    'Stack mobile : Kotlin Multiplatform, Flutter',
    'Backend & cloud : Firebase, Spring Boot, Supabase',
    'CI/CD, tests automatisés et architecture produit',
  ] : [
    'Co-founder & CTO at TheGift SAS — live on App Store and Google Play',
    'Mobile stack: Kotlin Multiplatform, Flutter',
    'Backend & cloud: Firebase, Spring Boot, Supabase',
    'CI/CD, automated testing and product architecture',
  ];

  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-main">
          <div className="section-intro">
            <h2 className="heading">
              {isFrench ? <>À propos de <span>moi</span></> : <>About <span>Me</span></>}
            </h2>
            <p className="section-subtitle">{t('aboutDescription')}</p>
          </div>

          <p className="about-role">{t('passionateDeveloper')}</p>

          <ul className="about-highlights">
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="about-actions">
            <Link to="/experience" className="btn primary">
              <Briefcase size={16} />
              <span>{isFrench ? 'Expériences' : 'Experience'}</span>
            </Link>
            <Link to="/skills" className="btn secondary">
              <Code size={16} />
              <span>{isFrench ? 'Compétences' : 'Skills'}</span>
            </Link>
          </div>
        </div>

        <aside className="about-sidebar">
          <div className="about-facts">
            {facts.map((fact) => (
              <div key={fact.label} className="about-fact">
                <span className="about-fact-label">{fact.label}</span>
                <span className="about-fact-value">{fact.value}</span>
              </div>
            ))}
          </div>
          <div className="about-stats">
            <div className="about-stat">
              <span className="about-stat-value">5+</span>
              <span className="about-stat-label">{t('projectsCompleted')}</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-value">10+</span>
              <span className="about-stat-label">{t('technologiesMastered')}</span>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default About;
